import github_logo from './github_logo_new.png';
import eand_logo from './eand_logo.jpeg';
import intertec_logo from './intertec_logo.jpeg';
import jj_pic from './jj_pic.JPG';
import email_logo from './email_logo.png';
import linkedin_logo from './linkedin_logo.png';
import harvard from './harvard.png';
import aws from './aws.png';
import google from './google.png';
import azure from './azure.png';
import c_hash from './c_hash.png';
import c_plus from './c_plus.png';
import c from './c.png';
import css from './css.png';
import docker from './docker.png';
import express from './express.png';
import flask from './flask.png';
import gcp from './gcp.png';
import git from './git.png';
import html from './html.png';
import java from './java.png';
import js from './js.png';
import kubernetes from './kubernetes.png';
import matlab from './matlab.png';
import mongodb from './mongodb.png';
import node from './node.png';
import opencv from './opencv.png';
import pandas from './pandas.png';
import python from './python.png';
import pytorch from './pytorch.png';
import react from './react.png';
import sql from './sql.png';
import tensorflow from './tensorflow.png';
import ts from './ts.png';
import opengl from './opengl.png';
import matplotlib from './matplotlib.png';
import numpy from './numpy.png';
import vite from './vite.png';
import langchain from './langchain.png';
import stripe from './stripe.png';
import name_text from './name_text.png';
import name_text_black from './name_text_black.png';
import card_sound from './card_sound.m4a';
import uoft_logo from './uoft_logo.jpg'
import background from './background.jpeg';
import vue from './vue.png';
import kotlin from './kotlin.png';
import firebase from './firebase.png';
import android from './android.png';
import postgresql from './postgresql.svg';
import mysql from './mysql.png';
import chromadb from './chromadb.png'
import r from './r.svg.png'
import iai from './iai.jpeg'
import coubon_logo from './coubon_logo.jpeg'
import smart_mate_logo from './smart_mate_logo.jpeg'
import background_video from './background_video.mp4'
import equifax_logo from './equifax_logo.png'
import altera_logo from './altera_logo.png'
import jj_pic_2026 from './jj_pic_2026.png'

export const assets = {
    github_logo,
    eand_logo,
    intertec_logo,
    jj_pic,
    uoft_logo,
    email_logo,
    linkedin_logo,
    harvard,
    aws,
    google,
    azure,
    c,
    c_hash,
    c_plus,
    css,
    docker,
    express,
    flask,
    gcp,
    git,
    html,
    java,
    js,
    kubernetes,
    matlab,
    mongodb,
    node,
    opencv,
    pandas,
    python,
    pytorch,
    react,
    sql,
    tensorflow,
    ts,
    numpy,
    matplotlib,
    opengl,
    vite,
    langchain,
    stripe,
    name_text,
    name_text_black,
    card_sound,
    background,
    vue,
    kotlin,
    firebase,
    android,
    postgresql,
    mysql,
    chromadb,
    r,
    iai,
    coubon_logo,
    smart_mate_logo,
    background_video,
    equifax_logo,
    altera_logo,
    jj_pic_2026
}